import React, { useEffect, useState } from "react";
import { useUsersContext } from "../../../context/usersContext";
import { useAppServices } from "../../../hook/services";
import { useUserInfo } from "../../../context/user";

const TOTAL_STEPS = 5;

const stepText = [
  {
    primary: '"We turned a strategy doc into a £2.5k/month product."',
    sec: "Keith Fonseca, CEO, AJF Financial Group",
  },
  { primary: "“We want one platform”", sec: "" },
  { primary: "“We want one platform”", sec: "✅ Unified AI Agent Framework" },
  { primary: "“It must sound like us”", sec: "" },
  {
    primary: "“It must sound like us”",
    sec: "✅ Voice-trained agents, fully brand-aligned",
  },
];

const YoureAllSet = ({ success, onComplete }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const { agency } = useUsersContext();

  useEffect(() => {
    if (currentStep >= TOTAL_STEPS - 1) return;

    let delay;
    if (currentStep < TOTAL_STEPS - 1) {
      delay = 8000; // steps 0-3: 8 seconds
    } else {
      delay = 20000; // step 4: 20 seconds
    }

    const timer = setTimeout(() => {
      if (currentStep < TOTAL_STEPS) {
        setCurrentStep((prev) => prev + 1);
      }
    }, delay);

    return () => clearTimeout(timer);
  }, [currentStep]);

  useEffect(() => {
    if (currentStep <= TOTAL_STEPS && !success) {
      onComplete();
    }
  }, [currentStep, success]);


  return (
    <div className="h-full !bg-white">
      <div className="container !bg-white !mt-0 h-full">
        <div className="text-center mt-32">
          <h1 className="text-3xl font-semibold">
            {currentStep <= 2 && (
              <span>
                Training your AI Agents to work like a trusted teammate…
              </span>
            )}
            {currentStep === 3 && (
              <span>
                {" "}
                Making sure your AI Agents understand your brand and culture…
              </span>
            )}
            {currentStep === 4 && <span>Understanding your brand…</span>}
          </h1>
          <p className="mt-4">
            {currentStep === 0 && (
              <span>We'll have you up and running in just a moment...</span>
            )}
            {currentStep === 1 && (
              <span> Setting everything up behind the scenes…</span>
            )}
            {currentStep === 2 && <span> Almost ready to go…</span>}
            {currentStep === 3 && (
              <span> Just a moment while we align everything…</span>
            )}
            {currentStep === 4 && (
              <span>Final touches to get your team aligned…</span>
            )}
          </p>
        </div>

        <div className="flex items-center justify-center gap-12 mt-12">
          {Array.from({ length: TOTAL_STEPS }).map((_, index) => {
            const isFilled = index < currentStep;
            const isActive =
              index === currentStep && (currentStep < TOTAL_STEPS || !success);
            const isLastWaiting =
              index === TOTAL_STEPS - 1 &&
              currentStep === TOTAL_STEPS &&
              !success;
            const pulseDuration = !success
              ? "animate-ping-fast"
              : "animate-ping-slow";

            return (
              <div key={index} className="flex items-center relative">
                <div className="relative">
                  <div
                    className={`w-8 h-8 rounded-full flex items-center justify-center border-2 ${isFilled
                      ? "bg-[#5C6CFF] border-[#5C6CFF]"
                      : isActive || isLastWaiting
                        ? "border-[#5C6CFF]"
                        : "border-[#C6C6C6]"
                      }`}
                  >
                    {(isActive || isLastWaiting) && (
                      <div className="w-2 h-2 rounded-full bg-[#5C6CFF]" />
                    )}
                  </div>

                  {(isActive || isLastWaiting) && (
                    <div
                      className={`absolute top-0 left-0 w-8 h-8 rounded-full bg-[#5C6CFF] opacity-75 ${pulseDuration}`}
                    />
                  )}
                </div>

                {index < TOTAL_STEPS - 1 && (
                  <div
                    className={`w-12 left-[100%] top-1/2 h-0.5 absolute ${index < currentStep ? "bg-[#5C6CFF]" : "bg-[#C6C6C6]"
                      }`}
                  />
                )}
              </div>
            );
          })}
        </div>
        <div className="text-center h-[65%] flex flex-col justify-end">
          <h3 className="text-xl">
            {
              agency?.train_your_ai?.[
              currentStep > TOTAL_STEPS ? TOTAL_STEPS : currentStep
              ]
            }
          </h3>
        </div>
      </div>
    </div>
  );
};

export default YoureAllSet;
